import { lazy, Suspense } from 'react';
import { LoadingBlock } from './components/bits';

const List = lazy(() => import('./pages/customers-list-page').then((m) => ({ default: m.CustomersListPage })));
const Detail = lazy(() => import('./pages/customer-detail-page').then((m) => ({ default: m.CustomerDetailPage })));

const fallback = <LoadingBlock rows={4} />;

/** Páginas do módulo de clientes, carregadas sob demanda (a rota e a permissão ficam em app/routes.tsx). */
export const CustomersListRoute = () => (
  <Suspense fallback={fallback}>
    <List />
  </Suspense>
);
export const CustomerDetailRoute = () => (
  <Suspense fallback={fallback}>
    <Detail />
  </Suspense>
);
